<template>
    <div class="h-full w-full">
        <base-form class="h-full w-full">
            <template #body>
                <div v-if="contacts.length > 0" class="w-full h-fit">
                    <div class="grid grid-cols-2 p-1 pb-3 border-b border-b-light-primary" v-for="contact in contacts" :key="contact.id">
                        <div class="flex flex-col w-full border-r border-dotted border-light-primary justify-start items-start px-3">
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Prefix:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactPrefixCell class="inline" :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">First Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactFirstNameCell class="inline" :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Middle Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactMiddleNameCell class="inline" :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Last Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactLastNameCell :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Suffix:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactSuffixCell :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Preferred Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactPreferredNameCell :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Email:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactPersonalEmailCell :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Phone:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <CompanyContactPhoneCell class="w-fit" :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">LinkedIn Profile:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ContactLinkedInCell :contact="contact.contact" @refetch-contacts="refetchCompanies" />
                                </div>
                            </div>
                            <div class="flex flex-col items-start py-0.5 w-full">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Notes:</div>
                                <!-- <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div> -->
                                <div class="flex">
                                   <CompanyContactPersonalNotesCell :company-contact="contact.contact" @refetch-companies="refetchCompanies" />
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col w-full justify-between items-start px-3">
                            <div class="flex flex-col w-full justify-start items-start">
                                <!-- <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Prefix:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <CompanyContactPrefixCell class="inline" :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div> -->
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Title:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <CompanyContactTitleCell :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Email:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <CompanyContactBusinessEmailCell :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Phone:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <CompanyContactBusinessPhoneCell :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Is Primary:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <CompanyContactIsPrimaryCell :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div>
                                <div class="flex flex-col items-start py-0.5 w-full">
                                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Users:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex">
                                        <ContactUsersCell :contact="contact" :user-options="userOptions" @refetch-contacts="refetchCompanies" />
                                    </div>
                                </div>
                                <div class="flex flex-col items-start py-0.5 w-full">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Notes:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex">
                                        <CompanyContactBusinessNotesCell :company-contact="contact" @refetch-companies="refetchCompanies" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-full flex flex-col justify-end items-end">
                                <div class="flex flex-row justify-end items-center col-span-2 2xl:col-span-4 space-x-1 w-full">
                                    <CompanyContactMarkEmailVerifiedCell class="inline"  :company-contact="contact" @refetch-companies="refetchCompanies"  />
                                    <base-button-negative @click="removeCompanyContact(contact)">Archive</base-button-negative>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    --
                </div>
                <CompanyContactForm class="" v-for="(row, index) in formRows" :key="row.key" :company="row.company" @refetch-companies="refetchCompanies" @close-form="closeContactRow(index)"/>
            </template>
            <template #footer>
                <div class="flex flex-row justify-end py-0.5">
                    <base-button @click="addFormRow">Add Contact</base-button>
                </div>
            </template>
        </base-form>
    </div>
</template>

<script>
export default {
    name: 'all-contacts-list'
}
</script>

<script setup>
    import {ref, computed, defineProps, defineEmits } from "vue";
    import { useStore } from "vuex";
    import CompanyContactPrefixCell from "./CompanyContactPrefixCell.vue";
    import CompanyContactFirstNameCell from './CompanyContactFirstNameCell.vue';
    import CompanyContactMiddleNameCell from "./CompanyContactMiddleNameCell.vue";
    import CompanyContactLastNameCell from './CompanyContactLastNameCell.vue';
    import CompanyContactSuffixCell from './CompanyContactSuffixCell.vue';
    import CompanyContactTitleCell from './CompanyContactTitleCell.vue';
    import CompanyContactPersonalEmailCell from './CompanyContactPersonalEmailCell.vue';
    import CompanyContactPhoneCell from './CompanyContactPhoneCell.vue';
    import ContactLinkedInCell from "../contact/contact-cell-components/ContactLinkedInCell.vue";
    import CompanyContactPersonalNotesCell from './CompanyContactPersonalNotesCell.vue';
    import CompanyContactIsPrimaryCell from "./CompanyContactIsPrimaryCell.vue";
    import CompanyContactForm from "../CompanyContactForm.vue";
    import CompanyContactBusinessEmailCell from "./CompanyContactBusinessEmailCell.vue";
    import CompanyContactBusinessPhoneCell from "./CompanyContactBusinessPhoneCell.vue";
    import CompanyContactBusinessNotesCell from "./CompanyContactBusinessNotesCell.vue";
    import CompanyContactMarkEmailVerifiedCell from "./CompanyContactMarkEmailVerifiedCell.vue";
    import CompanyContactPreferredNameCell from "./CompanyContactPreferredNameCell.vue";
    import ContactUsersCell from "../contact/contact-cell-components/ContactUsersCell.vue";
    import {updateContactCompanyRelationship} from '@/services/Contact.js'
    import { getUsers } from "@/services/User";
    import { useToast } from 'vue-toast-notification';

  
    const store = useStore()
    const $toast = useToast()

    const formRows = ref([])
  
    const props = defineProps({
        company: Object
    })

    const userOptions = ref([])

    const showContactForm = ref(false)
  
    const emit = defineEmits(['refetch-companies', 'close'])
  
    function refetchCompanies () {
        emit('refetch-companies')
    }
  
    const contacts = computed(() => {
        return props.company.contacts
    })

    function contactCompanyRelationships (contact) {
        return contact.company_relationships.filter(relationship => relationship.company_id == props.company.id)[0]
    }

    function addFormRow(){
        formRows.value.push(
        {key: Math.random(), company: props.company}
        )
    }
    function closeContactRow(index) {
        formRows.value.splice(index, 1)
        // emit('close')
    }

    async function removeCompanyContact(contact){
        const confirm_message = `You are about to archive ${contact.contact.first_name} ${contact.contact.last_name}, ${contact.title} at ${props.company.company_name}.\n Do you wish to proceed?`
        if(window.confirm(confirm_message)){
            const token = store.state.auth.token
            const data = JSON.stringify({
                "status": "inactive"
            })
            const response = await updateContactCompanyRelationship(contact.id, data, token)
            if (response.status == 200){
                $toast.open(
                    {
                        message: `Contact archived for ${props.company.company_name}`,
                        type: 'success',
                        duration: 10000
                    }
                )
                emit('refetch-companies')
                // emit('close')
            } else {
                $toast.open(
                    {
                        message: `${response.response.data.detail}`,
                        type: 'error',
                        duration: 10000
                    }
                )
            }
        }

    }

async function setUserOptions() {
  const token = store.getters['auth/showToken']
  const payload = {
    endpoint: "?is_active=True",
    token: token
  }
  const result = await getUsers(payload)
  userOptions.value = result.users.map((user) => {
      return {value: user.id, label: `${user.first_name} ${user.last_name}`}
  })
}

setUserOptions()
</script>